<template>
  <div class="index-container">
    <Heading class="title" level="1" weight="400"> NAUTICUS AIRDROP </Heading>
    <p class="description">
      Expand the reach of your project by participating in the Nauticus Airdrop,
      featuring one airdrop a day for a week to the Nauticus Network in 50+
      countries. Coming soon in 2019.
    </p>
    <ButtonBase
      class="button"
      size="large"
      variant="primary"
      margin-t="40px"
      block
      rounded
      @click="goToRegister"
    >
      REGISTER YOUR PROJECT</ButtonBase
    >
    <p class="extra-info">
      For more information, please email
      <a href="mailto:listing@nauticus.exchange">listing@nauticus.exchange</a>
    </p>
  </div>
</template>

<script>
import { Heading, ButtonBase } from '@nauticus-blockchain/nauticus-ui'
export default {
  name: 'Index',
  components: { Heading, ButtonBase },
  methods: {
    goToRegister() {
      this.$router.push({ name: 'Register' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@nauticus-blockchain/nauticus-ui/src/assets/styles/variables';
@import '~@nauticus-blockchain/nauticus-ui/src/assets/styles/mixins';

.index-container {
  text-align: center;
  left: 0;
  right: 0;
  position: absolute;
  top: 42vh;
  transform: translateY(-50%);
  z-index: 10;

  display: flex;
  align-self: flex-start;
  flex-direction: column;
  justify-content: center;
  margin: 3rem auto;
  padding: 0 20px;
  max-width: 622px;
  width: calc(100% - 40px);
}

.title {
  font-size: 48px !important;
  font-weight: 400 !important;
  margin-bottom: 70px;
  letter-spacing: 0.5px;

  @include at-query($max, 550px) {
    font-size: 36px !important;
    margin-bottom: 0px !important;
  }
}

.description {
  color: #b7b7b7;
  font-size: 16px;
  margin-bottom: 65px;
  line-height: 1.45em;
  font-weight: normal;

  @include at-query($max, 550px) {
    margin-bottom: 20px !important;
  }
}

.button {
  padding-left: 0;
  padding-right: 0;

  &:hover {
    border-color: $blue;
    background-color: transparent;
    color: $blue;
  }
}

.extra-info {
  font-size: 14px;
  color: #dddddd;
  margin-top: 20px;

  a {
    color: #dddddd;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
